import { Link } from 'gatsby'
import React, { useEffect, useRef } from 'react'
import FilterNav from './FilterNav'

const DemiColourNav = () => {
  const ref = useRef()

  useEffect(() => {
    const scrollWrapper =
      // @ts-ignore
      ref && ref.current

    const activeLink =
      // @ts-ignore
      scrollWrapper && scrollWrapper.querySelector('.active-page-link')

    activeLink &&
      scrollWrapper.scrollTo({
        left: activeLink.getBoundingClientRect().left - 20, // account for `siteXPadding`
        behavior: 'smooth',
      })
  }, [])

  return (
    <FilterNav ref={ref}>
      <Link to="/training/" replace activeClassName="active-page-link">
        Videos
      </Link>
      <Link
        to="/training/training-materials/"
        replace
        activeClassName="active-page-link"
      >
        PDFs
      </Link>
    </FilterNav>
  )
}

export default DemiColourNav
